var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyanInkDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.6654C3.58333 21.6654 0 18.082 0 13.6654C0 9.86537 5.425 2.7362 6.94167 0.819531C7.19167 0.507031 7.5625 0.332031 7.9625 0.332031H8.0375C8.4375 0.332031 8.80833 0.507031 9.05833 0.819531C10.575 2.7362 16 9.86537 16 13.6654C16 18.082 12.4167 21.6654 8 21.6654ZM4 14.332C4 13.9654 3.7 13.6654 3.33333 13.6654C2.96667 13.6654 2.66667 13.9654 2.66667 14.332C2.66667 16.9112 4.75417 18.9987 7.33333 18.9987C7.7 18.9987 8 18.6987 8 18.332C8 17.9654 7.7 17.6654 7.33333 17.6654C5.49167 17.6654 4 16.1737 4 14.332Z",
    fill: "#A0F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyanInkDrop);
export default __webpack_public_path__ + "static/media/cyanInkDrop.d5847375b2cad096756496b912f62250.svg";
export { ForwardRef as ReactComponent };